import { useLanguageStore } from '@darkchat/sdk'
import CookieConsent from 'react-cookie-consent'

export function CookieConsentBanner() {
  const { language } = useLanguageStore()

  const texts = {
    ja: {
      message: 'DarkChatは、サービスの提供と改善のためにCookieとローカルストレージを使用します。継続することで、',
      privacyLink: 'プライバシーポリシー',
      privacyLinkSuffix: 'に同意したものとみなされます。',
      acceptButton: '深淵へ進む',
      declineButton: '拒絶する',
    },
    en: {
      message: 'DarkChat doth employ cookies and local storage to provide and improve the Service. By proceeding, thou dost consent to our ',
      privacyLink: 'Privacy Policy',
      privacyLinkSuffix: '.',
      acceptButton: 'Descend into the Abyss',
      declineButton: 'Reject',
    },
  }

  const text = texts[language]
  const privacyUrl = `/codex/${language}/privacy`

  return (
    <CookieConsent
      location="bottom"
      buttonText={text.acceptButton}
      declineButtonText={text.declineButton}
      enableDeclineButton
      cookieName="darkchat-cookie-consent"
      expires={365}
      overlay
      overlayClasses="cookie-consent-overlay"
      style={{
        background: 'linear-gradient(to top, #0a0a0a 0%, rgba(10, 10, 10, 0.98) 100%)',
        borderTop: '1px solid rgba(139, 0, 0, 0.3)',
        padding: '1rem 2rem',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.875rem',
        zIndex: 9999,
      }}
      buttonStyle={{
        background: 'linear-gradient(to bottom, #1a1a1a 0%, #0f0f0f 100%)',
        color: '#e8e6e3',
        border: '1px solid rgba(139, 0, 0, 0.5)',
        borderRadius: '0',
        padding: '0.5rem 1.5rem',
        fontSize: '0.875rem',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
      }}
      buttonWrapperClasses="cookie-consent-buttons"
      declineButtonStyle={{
        background: 'transparent',
        color: '#a8a6a3',
        border: '1px solid rgba(168, 166, 163, 0.3)',
        borderRadius: '0',
        padding: '0.5rem 1.5rem',
        fontSize: '0.875rem',
        fontWeight: '400',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        marginRight: '1rem',
      }}
      contentStyle={{
        flex: '1 0 300px',
        margin: '0 1rem',
        color: '#e8e6e3',
      }}
      onAccept={() => {
        console.log('[CookieConsent] User accepted cookies')
      }}
      onDecline={() => {
        console.log('[CookieConsent] User declined cookies')
      }}
    >
      <span style={{ color: '#e8e6e3' }}>
        {text.message}
        <a
          href={privacyUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#8B0000',
            textDecoration: 'underline',
            marginLeft: '0.25rem',
            marginRight: '0.25rem',
          }}
        >
          {text.privacyLink}
        </a>
        {text.privacyLinkSuffix}
      </span>
    </CookieConsent>
  )
}
